module.exports = __webpack_public_path__ + "static/media/prestamos_viejo.fe530bca.svg";